

import React, { Fragment as F,
  useContext, useEffect, useLayoutEffect, useRef, useState,
} from 'react'

import {
  useApiRouter,
  appRouter,
  C,
  logg,
} from '$shared'

import {
  AppCtx,
} from '$src/App'

import DocShow from './DocShow'

import DocsSearch from './DocsSearch'

/* sg */
import ScheduleShow from './ScheduleShow'
/* pl */
import SchedulesCtx from './SchedulesCtx'
import SchedulesList from './SchedulesList'
import SchedulesShowModal from './SchedulesShowModal'

const formatLineitem = (what, item) => {
  // logg([what, item], 'formatLineitem')
  what = `${what}`
  if ('null' === what) {
    return "-"
  }

  switch (item.Data_Type) {
    case 'string':
      if ("0" === what) {
        return "-"
      } else {
        return what
      }
    case 'rating decimal':
      return what
    case 'ratio money/money':
    case 'ratio number/number':
    case 'money':
      if ('-' === what[0]) {
        return `(${ what.slice(1, what.length) })`
      } else if ('%' === what) {
        return "-"
      } else {
        return what
      }
    default:
      return what
  }
}

/**
 * SchedulesProvider
**/
const SchedulesProvider = ({ children, ...props }) => {

  const apiRouter = useApiRouter()

  const {
    cuEmail,
  } = useContext(AppCtx)

  const scheduleShowRef = useRef(null)

  const defaultOneResultTitle = 'FedFis Digital Prospector'
  const [ oneResultTitle, setOneResultTitle ] = useState(defaultOneResultTitle)
  const [ schedulesList,  setSchedulesList  ] = useState([])
  const [ schedulesOpen,  setSchedulesOpen  ] = useState(C.classes.sidebarIsOpen)

  const [ schedulesModalOpen, setSchedulesModalOpen ] = useState(false)
  const [ schedulesResults, setSchedulesResults ] = useState([])

  useEffect(() => {
    if (!cuEmail) { return }
    fetch(apiRouter.schedulesPath()).then(r => r.json()).then(schs => {
      // logg(schs, 'got schedules')
      setSchedulesList(schs)
    })
  }, [ cuEmail ])


  return <SchedulesCtx.Provider value={{
    oneResultTitle, setOneResultTitle, defaultOneResultTitle,

    // singular
    scheduleShowRef,

    // plural
    schedulesList,      setSchedulesList,
    schedulesModalOpen, setSchedulesModalOpen,
    schedulesOpen,      setSchedulesOpen,
    schedulesResults,   setSchedulesResults,
  }} >
    { children }
  </SchedulesCtx.Provider>
}

export {
  // sg
  DocShow,
  // pl
  DocsSearch,

  formatLineitem,

  // singular
  ScheduleShow,

  // plural
  SchedulesCtx,
  SchedulesList,
  SchedulesProvider,
  SchedulesShowModal,
}
